webpackJsonp([14],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DECREMENT_MAIN_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return INCREMENT_MAIN_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NEXT_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PREV_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GO_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHANGE_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SAVE_CHECKIN_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CHANGE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CHANGE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CHANGE_ADBLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SYSTEM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SYSTEM_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAR_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_CAMPAIGN_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SYSTEM_URL_COUNTRY; });
var DECREMENT_MAIN_COUNTER = 'DECREMENT_MAIN_COUNTER';
var INCREMENT_MAIN_COUNTER = 'INCREMENT_MAIN_COUNTER';
var NEXT_STEP = 'NEXT_STEP';
var PREV_STEP = 'PREV_STEP';
var GO_STEP = 'GO_STEP';
var CHANGE_LOGIN = 'CHANGE_LOGIN';
var LOGOUT = 'LOGOUT';
var LOGIN = 'LOGIN';
var SAVE_CHECKIN_INFO = 'SAVE_CHECKIN';
var CHANGE_MENU = 'CHANGE_MENU';
var CHANGE_CAMPAIGN = 'CHANGE_CAMPAIGN';
var CHANGE_ADBLOCK = 'CHANGE_ADBLOCK';
var SET_SYSTEM_NAME = 'SET_SYSTEM_NAME';
var SET_SYSTEM_VALUE = 'SET_SYSTEM_VALUE';
var SET_NOTIFICATION = 'SET_NOTIFICATION';
var CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
var SET_CAMPAIGN_FORM = 'SET_CAMPAIGN_FORM';
var SET_SYSTEM_URL_COUNTRY = 'SET_SYSTEM_URL_COUNTRY';

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__ = __webpack_require__(210);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: __WEBPACK_IMPORTED_MODULE_4__modules__["default"],
  strict: true,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__["a" /* default */])({
    key: 'self_serve_adv'
  })]
}));

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mondoconnex-menu-logo.ec08d2b.svg";

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  remoteHost: "production" === 'development' || location.host.indexOf('.test.') >= 0 ? 'https://www.mondocheckin.com/portal/' : 'https://www.mondocheckin.com/portal/',
  basicURL:  false ? '' : '',
  ewayEncryptKey: 'kDx5k07BO5AutY2xNBc09ZF50qyrzIFimjLIqShHUJII0QVPp4uK6YF3QmHg15CLZE0RtqDgMxpqYcYG6wtlwK5b2Zi7mTpyQYV+uf7oqupuq7P0yMt0v3wJTM9EymG+ntV3N34oohArgGznyLAuAU/P6O7gLE1ong5oD9KymNMyk4k2Jy2bH1Qanw8MFE7nX+w39urTPi6JD7aFixJdVAltVnbCLnS412+KR5/9H6ySXqepwFrxupj2xBgfToTUYI8FANq9cnF/yH0nPo14o8AWg0mxDic8BVjar/nC5QzHvw4krsJgZSqYPbsoTBtSua+jm6+g1Hg8xVXV36yt8Q==',
  userToken: 'accessToken'
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(15);
/* eslint-disable no-unused-vars */




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var defaultPath =  false ? '' : '';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: defaultPath + '/',
    name: 'Your Campaigns',
    meta: {
      requireAuth: true
    },
    redirect: '/venue/list'
  },
  /**
   * login section
   */
  {
    path: defaultPath + '/login',
    name: 'Login',
    meta: {
      noLogin: true,
      title: 'Mondo CheckIn | Log In'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 224));
    }
  }, {
    path: defaultPath + '/forgot',
    name: 'Forgot Password',
    meta: {
      noLogin: true,
      title: 'Mondo CheckIn | Forgot Password'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 223));
    }
  }, {
    path: defaultPath + '/resetPassword',
    name: 'Reset Password',
    meta: {
      noLogin: true,
      title: 'Mondo CheckIn | Reset Password'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 225));
    }
  },

  /**
   * end login sction
   */

  /**
   * venue section
   */
  {
    path: defaultPath + '/venue/list',
    name: 'Your Venues - List',
    meta: {
      requireAuth: true,
      title: 'Mondo CheckIn | Your Venues'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 226));
    }
  },

  /**
   * end venue section
   */

  {
    path: defaultPath + '/venue/leads',
    name: 'Venue Leads',
    meta: {
      requireAuth: true,
      requireAdmin: true,
      module: 'referral',
      title: 'Mondo CheckIn | Your Venue CheckIn Details'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 221));
    }
  }, {
    path: defaultPath + '/venue/marketing-list',
    name: 'Venue Marketing List',
    meta: {
      requireAuth: true,
      requireAdmin: true,
      module: 'referral',
      title: 'Mondo CheckIn | Your Venue CheckIn Marketing List'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 222));
    }
  }, {
    path: defaultPath + '/invoices',
    name: 'Your Invoices',
    meta: {
      requireAuth: true,
      requireAdmin: true
    },
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 217));
    }
  },

  /**
   * start user section
   */
  {
    path: defaultPath + '/account/profile',
    name: 'Account Profile',
    meta: {
      requireAuth: true,
      title: 'Mondo CheckIn | Your Profile'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 99));
    }
  }, {
    path: defaultPath + '/profile',
    name: 'Account Profile',
    meta: {
      requireAuth: true,
      title: 'Mondo CheckIn | Your Profile'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 99));
    }
  },
  /**
   * registration section
   */
  {
    path: defaultPath + '/registration',
    name: 'Registration',
    meta: {
      noLogin: true,
      title: 'Mondo CheckIn | Registration'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 218));
    }
  }, {
    path: defaultPath + '/test-registration',
    name: 'Registration',
    meta: {
      noLogin: true,
      title: 'Mondo CheckIn | Registration'
    },
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 219));
    }
  },
  /**
   * page section
   */
  {
    path: defaultPath + '/checkin/privacy',
    name: 'Venue CheckIn - Privacy',
    meta: {},
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 216));
    }
  },
  // {
  //   path: defaultPath + '/checkin/terms',
  //   name: 'Venue CheckIn - Privacy',
  //   meta: {
  //   },
  //   component: () => import('../components/page/element/checkin-tcContent')
  // },
  {
    path: defaultPath + '/venue/terms',
    name: 'Venue CheckIn - Terms',
    meta: {},
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 215));
    }
  }, {
    path: defaultPath + '/checkin/:id',
    name: 'Venue CheckIn',
    meta: {},
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 220));
    }
    /**
     * end page section
     */
  }]
});

router.beforeEach(function (to, from, next) {
  var defaultRoute = function defaultRoute() {
    if (__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.common.accessToken) {
      // if log in but no access for current system, then redirect to campaign list page
      next({
        path: '/'
      });
    } else {
      // if not log in but no access for current system, then redirect to registration page
      next({
        path: '/registration'
      });
    }
  };

  // set page title
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    if (to.name) {
      document.title = to.name;
    } else {
      document.title = 'Mondo CheckIn Portal';
    }
  }

  if (to.meta.requireAuth) {
    // need login or no
    if (__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.common.accessToken) {
      // vuex state to check login status
      if (to.meta.requireAdmin) {
        // need admin to access
        if (__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.common.admin) {
          next();
        } else {
          // if it is not admin, and not in the three layer account system
          next({
            path: '/'
          });
        }
      }
      next();
    } else {
      console.log(to);
      if (to.path === '/' || to.path === '/venue/list') {
        next({
          path: '/registration'
          // query: {redirect: to.fullPath} // put path as redirect after login
        });
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath // put path as redirect after login
          } });
      }
    }
  } else if (to.meta.noLogin) {
    if (!__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.common.accessToken) {
      // vuex state to check login status
      next();
    } else {
      next({
        path: '/',
        query: { redirect: to.fullPath // put path as redirect after login
        } });
    }
  } else {
    next();
  }
  // document.title = title
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Portal-Banner-Mondo-Menu.4f95593.png";

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(212);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var countryList = { au: 'Australia', us: 'United States', nz: 'New Zealand', id: 'Indonesia' };
if (location.host === 'eu-advertiser.opentop.com') {
  countryList = { es: 'Spain' };
}

// date constant
var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
/* harmony default export */ __webpack_exports__["a"] = ({
  dollarList: { 'au': '$', 'nz': '$', 'uk': '£', 'us': '$', 'es': '€', 'aud': '$', 'nzd': '$', 'ukp': '£', 'usd': '$', 'eur': '€', 'id': '$', 'idr': '$', '': '' },
  countryList: countryList, // {au: 'Australia', nz: 'New Zealand', uk: 'United Kingdom', us: 'United States', es: 'Spain'}
  stateList: {
    au: { 'ACT': 'Australian Capital Territory', 'NSW': 'New South Wales', 'NT': 'Northern Territory', 'QLD': 'Queensland', 'SA': 'South Australia', 'TAS': 'Tasmania', 'VIC': 'Victoria', 'WA': 'Western Australia' },
    us: { 'AL': 'Alabama', 'AK': 'Alaska', 'AS': 'American Samoa', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'DC': 'District Of Columbia', 'FM': 'Federated States Of Micronesia', 'FL': 'Florida', 'GA': 'Georgia', 'GU': 'Guam', 'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MH': 'Marshall Islands', 'MD': 'Maryland', 'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'MP': 'Northern Mariana Islands', 'OH': 'Ohio', 'OK': 'Oklahoma', 'OR': 'Oregon', 'PW': 'Palau', 'PA': 'Pennsylvania', 'PR': 'Puerto Rico', 'RI': 'Rhode Island', 'SC': 'South Carolina', 'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont', 'VI': 'Virgin Islands', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming' },
    nz: { 'auckland': 'Auckland', 'bay of plenty': 'Bay of Plenty', 'canterbury': 'Canterbury', 'gisborne': 'Gisborne', 'hawkes bay': 'Hawkes Bay', 'nelson': 'Nelson', 'northland': 'Northland', 'marlborough': 'Marlborough', 'manawatu-whanganui': 'Manawatu-Whanganui', 'otago': 'Otago', 'southland': 'Southland', 'taranaki': 'Taranaki', 'tasman': 'Tasman', 'waikato': 'Waikato', 'wellington': 'Wellington', 'west coast': 'West Coast' },
    es: { 'A Coruña': 'A Coruña', 'Álava': 'Álava', 'Albacete': 'Albacete', 'Alicante': 'Alicante', 'Almería': 'Almería', 'Asturias': 'Asturias', 'Ávila': 'Ávila', 'Badajoz': 'Badajoz', 'Barcelona': 'Barcelona', 'Burgos': 'Burgos', 'Cáceres': 'Cáceres', 'Cádiz': 'Cádiz', 'Cantabria': 'Cantabria', 'Castellón': 'Castellón', 'Ceuta': 'Ceuta', 'Ciudad Real': 'Ciudad Real', 'Córdoba': 'Córdoba', 'Cuenca': 'Cuenca', 'Girona': 'Girona', 'Granada': 'Granada', 'Guadalajara': 'Guadalajara', 'Guipúzcoa': 'Guipúzcoa', 'Huelva': 'Huelva', 'Huesca': 'Huesca', 'Islas Baleares': 'Islas Baleares', 'Jaén': 'Jaén', 'La Rioja': 'La Rioja', 'Las Palmas': 'Las Palmas', 'León': 'León', 'Lleida': 'Lleida', 'Lugo': 'Lugo', 'Madrid': 'Madrid', 'Málaga': 'Málaga', 'Melilla': 'Melilla', 'Murcia': 'Murcia', 'Navarra': 'Navarra', 'Ourense': 'Ourense', 'Palencia': 'Palencia', 'Pontevedra': 'Pontevedra', 'Salamanca': 'Salamanca', 'Santa Cruz de Tenerife': 'Santa Cruz de Tenerife', 'Segovia': 'Segovia', 'Sevilla': 'Sevilla', 'Soria': 'Soria', 'Tarragona': 'Tarragona', 'Teruel': 'Teruel', 'Toledo': 'Toledo', 'Valencia': 'Valencia', 'Valladolid': 'Valladolid', 'Vizcaya': 'Vizcaya', 'Zamora': 'Zamora', 'Zaragoza': 'Zaragoza' }
  },
  timeZone: {
    au: {
      'Australia/Adelaide': 'Australia/Adelaide (UTC/GMT +09:30)',
      'Australia/Brisbane': 'Australia/Brisbane (UTC/GMT +10:00)',
      'Australia/Broken_Hill': 'Australia/Broken_Hill (UTC/GMT +09:30)',
      'Australia/Currie': 'Australia/Currie (UTC/GMT +10:00)',
      'Australia/Darwin': 'Australia/Darwin (UTC/GMT +09:30)',
      'Australia/Eucla': 'Australia/Eucla (UTC/GMT +08:45)',
      'Australia/Hobart': 'Australia/Hobart (UTC/GMT +11:00)',
      'Australia/Lindeman': 'Australia/Lindeman (UTC/GMT +10:00)',
      'Australia/Lord_Howe': 'Australia/Lord_Howe (UTC/GMT +10:00)',
      'Australia/Melbourne': 'Australia/Melbourne (UTC/GMT +10:00)',
      'Australia/Perth': 'Australia/Perth (UTC/GMT +08:00)',
      'Australia/Sydney': 'Australia/Sydney (UTC/GMT +10:00)'
    },
    us: {
      'America/Adak': 'America/Adak (UTC/GMT -11:00)',
      'America/Anchorage': 'America/Anchorage (UTC/GMT -10:00)',
      'America/Anguilla': 'America/Anguilla (UTC/GMT -04:00)',
      'America/Antigua': 'America/Antigua (UTC/GMT -04:00)',
      'America/Araguaina': 'America/Araguaina (UTC/GMT -03:00)',
      'America/Argentina/Buenos_Aires': 'America/Argentina/Buenos_Aires (UTC/GMT -03:00)',
      'America/Argentina/Catamarca': 'America/Argentina/Catamarca (UTC/GMT -03:00)',
      'America/Argentina/Cordoba': 'America/Argentina/Cordoba (UTC/GMT -03:00)',
      'America/Argentina/Jujuy': 'America/Argentina/Jujuy (UTC/GMT -03:00)',
      'America/Argentina/La_Rioja': 'America/Argentina/La_Rioja (UTC/GMT -03:00)',
      'America/Argentina/Mendoza': 'America/Argentina/Mendoza (UTC/GMT -03:00)',
      'America/Argentina/Rio_Gallegos': 'America/Argentina/Rio_Gallegos (UTC/GMT -03:00)',
      'America/Argentina/Salta': 'America/Argentina/Salta (UTC/GMT -03:00)',
      'America/Argentina/San_Juan': 'America/Argentina/San_Juan (UTC/GMT -03:00)',
      'America/Argentina/San_Luis': 'America/Argentina/San_Luis (UTC/GMT -03:00)',
      'America/Argentina/Tucuman': 'America/Argentina/Tucuman (UTC/GMT -03:00)',
      'America/Argentina/Ushuaia': 'America/Argentina/Ushuaia (UTC/GMT -03:00)',
      'America/Aruba': 'America/Aruba (UTC/GMT -04:00)',
      'America/Asuncion': 'America/Asuncion (UTC/GMT -04:00)',
      'America/Atikokan': 'America/Atikokan (UTC/GMT -05:00)',
      'America/Bahia': 'America/Bahia (UTC/GMT -03:00)',
      'America/Bahia_Banderas': 'America/Bahia_Banderas (UTC/GMT -08:00)',
      'America/Barbados': 'America/Barbados (UTC/GMT -04:00)',
      'America/Belem': 'America/Belem (UTC/GMT -03:00)',
      'America/Belize': 'America/Belize (UTC/GMT -06:00)',
      'America/Blanc-Sablon': 'America/Blanc-Sablon (UTC/GMT -04:00)',
      'America/Boa_Vista': 'America/Boa_Vista (UTC/GMT -04:00)',
      'America/Bogota': 'America/Bogota (UTC/GMT -05:00)',
      'America/Boise': 'America/Boise (UTC/GMT -07:00)',
      'America/Cambridge_Bay': 'America/Cambridge_Bay (UTC/GMT -07:00)',
      'America/Campo_Grande': 'America/Campo_Grande (UTC/GMT -04:00)',
      'America/Cancun': 'America/Cancun (UTC/GMT -06:00)',
      'America/Caracas': 'America/Caracas (UTC/GMT -04:00)',
      'America/Cayenne': 'America/Cayenne (UTC/GMT -03:00)',
      'America/Cayman': 'America/Cayman (UTC/GMT -05:00)',
      'America/Chicago': 'America/Chicago (UTC/GMT -06:00)',
      'America/Chihuahua': 'America/Chihuahua (UTC/GMT -06:00)',
      'America/Costa_Rica': 'America/Costa_Rica (UTC/GMT -06:00)',
      'America/Creston': 'America/Creston (UTC/GMT -07:00)',
      'America/Cuiaba': 'America/Cuiaba (UTC/GMT -04:00)',
      'America/Curacao': 'America/Curacao (UTC/GMT -04:00)',
      'America/Danmarkshavn': 'America/Danmarkshavn (UTC/GMT -03:00)',
      'America/Dawson': 'America/Dawson (UTC/GMT -09:00)',
      'America/Dawson_Creek': 'America/Dawson_Creek (UTC/GMT -08:00)',
      'America/Denver': 'America/Denver (UTC/GMT -07:00)',
      'America/Detroit': 'America/Detroit (UTC/GMT -05:00)',
      'America/Dominica': 'America/Dominica (UTC/GMT -04:00)',
      'America/Edmonton': 'America/Edmonton (UTC/GMT -07:00)',
      'America/Eirunepe': 'America/Eirunepe (UTC/GMT -05:00)',
      'America/El_Salvador': 'America/El_Salvador (UTC/GMT -06:00)',
      'America/Fort_Nelson': 'America/Fort_Nelson (UTC/GMT -08:00)',
      'America/Fortaleza': 'America/Fortaleza (UTC/GMT -03:00)',
      'America/Glace_Bay': 'America/Glace_Bay (UTC/GMT -04:00)',
      'America/Godthab': 'America/Godthab (UTC/GMT -03:00)',
      'America/Goose_Bay': 'America/Goose_Bay (UTC/GMT -04:00)',
      'America/Grand_Turk': 'America/Grand_Turk (UTC/GMT -05:00)',
      'America/Grenada': 'America/Grenada (UTC/GMT -04:00)',
      'America/Guadeloupe': 'America/Guadeloupe (UTC/GMT -04:00)',
      'America/Guatemala': 'America/Guatemala (UTC/GMT -06:00)',
      'America/Guayaquil': 'America/Guayaquil (UTC/GMT -05:00)',
      'America/Guyana': 'America/Guyana (UTC/GMT -03:45)',
      'America/Halifax': 'America/Halifax (UTC/GMT -04:00)',
      'America/Havana': 'America/Havana (UTC/GMT -05:00)',
      'America/Hermosillo': 'America/Hermosillo (UTC/GMT -08:00)',
      'America/Indiana/Indianapolis': 'America/Indiana/Indianapolis (UTC/GMT -05:00)',
      'America/Indiana/Knox': 'America/Indiana/Knox (UTC/GMT -06:00)',
      'America/Indiana/Marengo': 'America/Indiana/Marengo (UTC/GMT -05:00)',
      'America/Indiana/Petersburg': 'America/Indiana/Petersburg (UTC/GMT -06:00)',
      'America/Indiana/Tell_City': 'America/Indiana/Tell_City (UTC/GMT -05:00)',
      'America/Indiana/Vevay': 'America/Indiana/Vevay (UTC/GMT -05:00)',
      'America/Indiana/Vincennes': 'America/Indiana/Vincennes (UTC/GMT -05:00)',
      'America/Indiana/Winamac': 'America/Indiana/Winamac (UTC/GMT -05:00)',
      'America/Inuvik': 'America/Inuvik (UTC/GMT -08:00)',
      'America/Iqaluit': 'America/Iqaluit (UTC/GMT -05:00)',
      'America/Jamaica': 'America/Jamaica (UTC/GMT -05:00)',
      'America/Juneau': 'America/Juneau (UTC/GMT -08:00)',
      'America/Kentucky/Louisville': 'America/Kentucky/Louisville (UTC/GMT -05:00)',
      'America/Kentucky/Monticello': 'America/Kentucky/Monticello (UTC/GMT -06:00)',
      'America/Kralendijk': 'America/Kralendijk (UTC/GMT -04:00)',
      'America/La_Paz': 'America/La_Paz (UTC/GMT -04:00)',
      'America/Lima': 'America/Lima (UTC/GMT -05:00)',
      'America/Los_Angeles': 'America/Los_Angeles (UTC/GMT -08:00)',
      'America/Lower_Princes': 'America/Lower_Princes (UTC/GMT -04:00)',
      'America/Maceio': 'America/Maceio (UTC/GMT -03:00)',
      'America/Managua': 'America/Managua (UTC/GMT -06:00)',
      'America/Manaus': 'America/Manaus (UTC/GMT -04:00)',
      'America/Marigot': 'America/Marigot (UTC/GMT -04:00)',
      'America/Martinique': 'America/Martinique (UTC/GMT -04:00)',
      'America/Matamoros': 'America/Matamoros (UTC/GMT -06:00)',
      'America/Mazatlan': 'America/Mazatlan (UTC/GMT -08:00)',
      'America/Menominee': 'America/Menominee (UTC/GMT -05:00)',
      'America/Merida': 'America/Merida (UTC/GMT -06:00)',
      'America/Metlakatla': 'America/Metlakatla (UTC/GMT -08:00)',
      'America/Mexico_City': 'America/Mexico_City (UTC/GMT -06:00)',
      'America/Miquelon': 'America/Miquelon (UTC/GMT -04:00)',
      'America/Moncton': 'America/Moncton (UTC/GMT -04:00)',
      'America/Monterrey': 'America/Monterrey (UTC/GMT -06:00)',
      'America/Montevideo': 'America/Montevideo (UTC/GMT -03:00)',
      'America/Montserrat': 'America/Montserrat (UTC/GMT -04:00)',
      'America/Nassau': 'America/Nassau (UTC/GMT -05:00)',
      'America/New_York': 'America/New_York (UTC/GMT -05:00)',
      'America/Nipigon': 'America/Nipigon (UTC/GMT -05:00)',
      'America/Nome': 'America/Nome (UTC/GMT -11:00)',
      'America/Noronha': 'America/Noronha (UTC/GMT -02:00)',
      'America/North_Dakota/Beulah': 'America/North_Dakota/Beulah (UTC/GMT -07:00)',
      'America/North_Dakota/Center': 'America/North_Dakota/Center (UTC/GMT -07:00)',
      'America/North_Dakota/New_Salem': 'America/North_Dakota/New_Salem (UTC/GMT -07:00)',
      'America/Ojinaga': 'America/Ojinaga (UTC/GMT -06:00)',
      'America/Panama': 'America/Panama (UTC/GMT -05:00)',
      'America/Pangnirtung': 'America/Pangnirtung (UTC/GMT -04:00)',
      'America/Paramaribo': 'America/Paramaribo (UTC/GMT -03:30)',
      'America/Phoenix': 'America/Phoenix (UTC/GMT -07:00)',
      'America/Port-au-Prince': 'America/Port-au-Prince (UTC/GMT -05:00)',
      'America/Port_of_Spain': 'America/Port_of_Spain (UTC/GMT -04:00)',
      'America/Porto_Velho': 'America/Porto_Velho (UTC/GMT -04:00)',
      'America/Puerto_Rico': 'America/Puerto_Rico (UTC/GMT -04:00)',
      'America/Punta_Arenas': 'America/Punta_Arenas (UTC/GMT -03:00)',
      'America/Rainy_River': 'America/Rainy_River (UTC/GMT -06:00)',
      'America/Rankin_Inlet': 'America/Rankin_Inlet (UTC/GMT -06:00)',
      'America/Recife': 'America/Recife (UTC/GMT -03:00)',
      'America/Regina': 'America/Regina (UTC/GMT -06:00)',
      'America/Resolute': 'America/Resolute (UTC/GMT -06:00)',
      'America/Rio_Branco': 'America/Rio_Branco (UTC/GMT -05:00)',
      'America/Santarem': 'America/Santarem (UTC/GMT -04:00)',
      'America/Santiago': 'America/Santiago (UTC/GMT -03:00)',
      'America/Santo_Domingo': 'America/Santo_Domingo (UTC/GMT -04:30)',
      'America/Sao_Paulo': 'America/Sao_Paulo (UTC/GMT -03:00)',
      'America/Scoresbysund': 'America/Scoresbysund (UTC/GMT -02:00)',
      'America/Sitka': 'America/Sitka (UTC/GMT -08:00)',
      'America/St_Barthelemy': 'America/St_Barthelemy (UTC/GMT -04:00)',
      'America/St_Johns': 'America/St_Johns (UTC/GMT -03:30)',
      'America/St_Kitts': 'America/St_Kitts (UTC/GMT -04:00)',
      'America/St_Lucia': 'America/St_Lucia (UTC/GMT -04:00)',
      'America/St_Thomas': 'America/St_Thomas (UTC/GMT -04:00)',
      'America/St_Vincent': 'America/St_Vincent (UTC/GMT -04:00)',
      'America/Swift_Current': 'America/Swift_Current (UTC/GMT -07:00)',
      'America/Tegucigalpa': 'America/Tegucigalpa (UTC/GMT -06:00)',
      'America/Thule': 'America/Thule (UTC/GMT -04:00)',
      'America/Thunder_Bay': 'America/Thunder_Bay (UTC/GMT -05:00)',
      'America/Tijuana': 'America/Tijuana (UTC/GMT -08:00)',
      'America/Toronto': 'America/Toronto (UTC/GMT -05:00)',
      'America/Tortola': 'America/Tortola (UTC/GMT -04:00)',
      'America/Vancouver': 'America/Vancouver (UTC/GMT -08:00)',
      'America/Whitehorse': 'America/Whitehorse (UTC/GMT -08:00)',
      'America/Winnipeg': 'America/Winnipeg (UTC/GMT -06:00)',
      'America/Yakutat': 'America/Yakutat (UTC/GMT -09:00)',
      'America/Yellowknife': 'America/Yellowknife (UTC/GMT -07:00)'
    },
    es: {
      'Europe/Madrid': 'Europe/Madrid (UTC/GMT +01:00)'
    },
    nz: {
      'Pacific/Auckland': 'Pacific/Auckland (UTC/GMT +12:00)'
    },
    id: {
      'Asia/Jakarta': 'Jakarta (UTC/GMT +07:00)',
      'Asia/Ujung_Pandang': 'Central Indonesian Time (UTC/GMT +08:00)',
      'Asia/Jayapura': 'Jayapura (UTC/GMT +09:00)'
    }
  },
  defaultTimeZone: {
    au: { value: 'Australia/Melbourne', text: 'Australia/Melbourne (UTC/GMT +10:00)' },
    us: { value: 'America/New_York', text: 'America/New_York (UTC/GMT -05:00)' },
    es: { value: 'Europe/Madrid', text: 'Europe/Madrid (UTC/GMT +01:00' },
    nz: { value: 'Pacific/Auckland', text: 'Pacific/Auckland (UTC/GMT +12:00' },
    id: { value: 'Asia/Ujung_Pandang', text: 'Central Indonesian Time (UTC/GMT +08:00)' }
  },
  campaignCategory: {
    // '': 'Select Industry',
    'Accommodation': 'Accommodation',
    'Alcohol': 'Alcohol',
    'Automotive': 'Automotive',
    'Banking & Finance': 'Banking & Finance',
    'Bar & Restaurant': 'Bar & Restaurant',
    'Cafe': 'Cafe',
    'Charity': 'Charity',
    'Childcare': 'Childcare',
    'Consulting': 'Consulting',
    'Cruises': 'Cruises',
    'Deals': 'Deals',
    'Digital Printing': 'Digital Printing',
    'Education': 'Education',
    'Energy': 'Energy',
    'Entertainment': 'Entertainment',
    'Events': 'Events',
    'Finance': 'Finance',
    'Food': 'Food',
    'Gambling & Lottery': 'Gambling & Lottery',
    'Health & Beauty': 'Health & Beauty',
    'Health & Fitness': 'Health & Fitness',
    // Insurance
    'Insurance': 'Insurance:',
    'Automotive Insurance': 'Automotive',
    'Insurance Comparison': 'Comparison',
    'Funeral Insurance': 'Funeral',
    'Health Insurance': 'Health',
    'Life Insurance': 'Life',
    'Other Insurance': 'Other',
    'Travel Insurance': 'Travel',

    'Online Dating': 'Online Dating',
    'Other': 'Other',
    'Real Estate': 'Real Estate',
    // Retail
    'Retail': 'Retail:',
    'Camping Retail': 'Camping',
    'Department Store Retail': 'Department Store',
    'Electrical Retail': 'Electrical',
    'Fashion Retail': 'Fashion',
    'Hardware Retail': 'Hardware',
    'Home Retail': 'Home',
    'Nursery Retail': 'Nursery',
    'Office Retail': 'Office',
    'Other Retail': 'Other',
    'Pet Retail': 'Pet',
    'Vision Retail': 'Vision',

    'Security': 'Security',
    'Solar Energy': 'Solar Energy',
    'Sporting': 'Sporting',
    'Survey': 'Survey',
    'Telecommunication': 'Telecommunication',
    'Tours': 'Tourism',
    'Trade Services': 'Trade Services',
    'Travel': 'Travel',
    'Veterinary': 'Veterinary'
  },
  regionList: {
    'au': 'Australia', 'as': 'Asia', 'nz/oc': 'New Zealand', 'eu': 'Europe', 'na': 'North America', 'sa': 'South America', 'ma-sp': 'Middle East', 'af': 'Africa', 'uk': 'England'
  },
  lanList: {
    'af': 'Afrikaans',
    'ak': 'Akan',
    'sq': 'Albanian',
    'am': 'Amharic',
    'ar': 'Arabic',
    'hy': 'Armenian',
    'as': 'Assamese',
    'asa': 'Asu',
    'az': 'Azerbaijani',
    'bm': 'Bambara',
    'eu': 'Basque',
    'be': 'Belarusian',
    'bem': 'Bemba',
    'bez': 'Bena',
    'bn': 'Bengali',
    'bs': 'Bosnian',
    'bg': 'Bulgarian',
    'my': 'Burmese',
    'ca': 'Catalan',
    'tzm': 'Central Morocco Tamazight',
    'chr': 'Cherokee',
    'cgg': 'Chiga',
    'zh': 'Chinese',
    'kw': 'Cornish',
    'hr': 'Croatian',
    'cs': 'Czech',
    'da': 'Danish',
    'nl': 'Dutch',
    'ebu': 'Embu',
    'en': 'English',
    'eo': 'Esperanto',
    'et': 'Estonian',
    'ee': 'Ewe',
    'fo': 'Faroese',
    'fil': 'Filipino',
    'fi': 'Finnish',
    'fr': 'French',
    'ff': 'Fulah',
    'gl': 'Galician',
    'lg': 'Ganda',
    'ka': 'Georgian',
    'de': 'German',
    'el': 'Greek',
    'gu': 'Gujarati',
    'guz': 'Gusii',
    'ha': 'Hausa',
    'haw': 'Hawaiian',
    'he': 'Hebrew',
    'hi': 'Hindi',
    'hu': 'Hungarian',
    'is': 'Icelandic',
    'ig': 'Igbo',
    'id': 'Indonesian',
    'ga': 'Irish',
    'it': 'Italian',
    'ja': 'Japanese',
    'kea': 'Kabuverdianu',
    'kab': 'Kabyle',
    'kl': 'Kalaallisut',
    'kln': 'Kalenjin',
    'kam': 'Kamba',
    'kn': 'Kannada',
    'kk': 'Kazakh',
    'km': 'Khmer',
    'ki': 'Kikuyu',
    'rw': 'Kinyarwanda',
    'kok': 'Konkani',
    'ko': 'Korean',
    'khq': 'Koyra Chiini',
    'ses': 'Koyraboro Senni',
    'lag': 'Langi',
    'lv': 'Latvian',
    'lt': 'Lithuanian',
    'luo': 'Luo',
    'luy': 'Luyia',
    'mk': 'Macedonian',
    'jmc': 'Machame',
    'kde': 'Makonde',
    'mg': 'Malagasy',
    'ms': 'Malay',
    'ml': 'Malayalam',
    'mt': 'Maltese',
    'gv': 'Manx',
    'mr': 'Marathi',
    'mas': 'Masai',
    'mer': 'Meru',
    'mfe': 'Morisyen',
    'naq': 'Nama',
    'ne': 'Nepali',
    'nd': 'North Ndebele',
    'nb': 'Norwegian Bokmål',
    'nn': 'Norwegian Nynorsk',
    'nyn': 'Nyankole',
    'or': 'Oriya',
    'om': 'Oromo',
    'ps': 'Pashto',
    'fa': 'Persian',
    'pl': 'Polish',
    'pt': 'Portuguese',
    'pa': 'Punjabi',
    'ro': 'Romanian',
    'rm': 'Romansh',
    'rof': 'Rombo',
    'ru': 'Russian',
    'rwk': 'Rwa',
    'saq': 'Samburu',
    'sg': 'Sango',
    'seh': 'Sena',
    'sr': 'Serbian',
    'sn': 'Shona',
    'ii': 'Sichuan Yi',
    'si': 'Sinhala',
    'sk': 'Slovak',
    'sl': 'Slovenian',
    'xog': 'Soga',
    'so': 'Somali',
    'es': 'Spanish',
    'sw': 'Swahili',
    'sv': 'Swedish',
    'gsw': 'Swiss German',
    'shi': 'Tachelhit',
    'dav': 'Taita',
    'ta': 'Tamil',
    'te': 'Telugu',
    'teo': 'Teso',
    'th': 'Thai',
    'bo': 'Tibetan',
    'ti': 'Tigrinya',
    'to': 'Tonga',
    'tr': 'Turkish',
    'uk': 'Ukrainian',
    'ur': 'Urdu',
    'uz': 'Uzbek',
    'vi': 'Vietnamese',
    'vun': 'Vunjo',
    'cy': 'Welsh',
    'yo': 'Yoruba',
    'zu': 'Zulu'
  },
  languageList: {
    'en': 'English',
    'zh': 'Chinese',
    'ko': 'Korean',
    'es': 'Spanish',
    'id': 'Indonesian'
  },
  skipBtnText: {
    'en': 'No Thanks',
    'zh': '不, 谢谢',
    'fr': 'Non merci',
    'ko': '고마워',
    'es': 'No, gracias',
    'id': 'Tidak terima kasih'
  },
  dateTools: {
    dayAbbreviation: dayAbbreviation,
    dayList: dayList,
    monthList: monthList,
    monthLongList: monthLongList,
    searchDateRangeOptions: { today: 'Today', yesterday: 'Yesterday', last_30_day: 'Last 30 Days', this_month: 'This Month', last_month: 'Last Month', custom: 'Custom' },
    searchDateAllRangeOptions: { all: 'All', today: 'Today', yesterday: 'Yesterday', last_30_day: 'Last 30 Days', this_month: 'This Month', last_month: 'Last Month', custom: 'Custom' },
    enDateFormat: {
      formatDisplay: function formatDisplay(date) {
        return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
      },
      formatMonth: function formatMonth(date) {
        return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
      },
      getWeekDayArray: function getWeekDayArray(firstDayOfWeek) {
        var beforeArray = [];
        var afterArray = [];
        for (var i = 0; i < dayAbbreviation.length; i++) {
          if (i < firstDayOfWeek) {
            afterArray.push(dayAbbreviation[i]);
          } else {
            beforeArray.push(dayAbbreviation[i]);
          }
        }
        return beforeArray.concat(afterArray);
      },
      getMonthList: function getMonthList() {
        return monthList;
      }
    },
    searchDateRangeToFromTo: function searchDateRangeToFromTo(val) {
      var result = { fromDate: '', toDate: '' };
      var getLastDaysDate = function getLastDaysDate(days, firstDay, months) {
        var date = new Date();
        var last = new Date(date.getTime() - days * 24 * 60 * 60 * 1000);
        if (months) {
          last = new Date(date.getFullYear(), date.getMonth() + months - 1, 0);
        }
        var day = last.getDate();
        var month = last.getMonth() + 1;
        var year = last.getFullYear();
        // return year + '-' + month + '-' + day
        if (firstDay === true) {
          day = 1;
        }
        return year + '-' + month + '-' + day;
      };

      switch (val) {
        case 'today':
          result.fromDate = getLastDaysDate(0);
          result.toDate = getLastDaysDate(0);
          break;
        case 'yesterday':
          result.fromDate = getLastDaysDate(1);
          result.toDate = getLastDaysDate(1);
          break;
        case 'last_7_day':
          result.fromDate = getLastDaysDate(6);
          result.toDate = getLastDaysDate(0);
          break;
        case 'last_28_day':
          result.fromDate = getLastDaysDate(27);
          result.toDate = getLastDaysDate(0);
          break;
        case 'last_56_day':
          result.fromDate = getLastDaysDate(55);
          result.toDate = getLastDaysDate(0);
          break;
        case 'last_30_day':
          result.fromDate = getLastDaysDate(29);
          result.toDate = getLastDaysDate(0);
          break;
        case 'this_month':
          result.fromDate = getLastDaysDate(0, true);
          result.toDate = getLastDaysDate(0);
          break;
        case 'last_month':
          result.fromDate = getLastDaysDate(0, true, 1);
          result.toDate = getLastDaysDate(0, false, 1); // always last day
          break;
        case 'custom':
        case 'all':
          result.fromDate = '';
          result.toDate = '';
          break;
        default:
          result.fromDate = getLastDaysDate(0);
          result.toDate = getLastDaysDate(0);
          break;
      }
      return result;
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/*
* Own util plugin, to provide global method
* @author Chao
* */
var siteUtil = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install: function install(Vue, options) {
    /*
    * Get notification from backend
    * Set notification in vuex store
    * Get will show notification and then show them on page
    * Will call this when route change (in App.vue)
    * @author Chao
    * */
    Vue.prototype.$checkNotify = function () {
      //       this.$store.commit('CLEAR_NOTIFICATION')
      //       // only show campaign create notification on campaign list page
      //       if (this.$route.path !== '/campaign/list' && this.$route.path !== '/yourcampaigns') {
      //         this.$notify({
      //           group: 'campaign-notification',
      //           clean: true
      //         })
      //       }
      //       /**
      //        * detect message for every page
      //        */
      //       if (this.login || force) {
      //         const self = this
      //         this.$http.get('/advertiser/user/receive-notice')
      //           .then(response => {
      //             // eslint-disable-next-line quotes
      //             // response.data = {"success": true, "data": [{"id": "asdfsadf", "type": 3, "message": "bbbbbbbbb", "action": {"id": "3bfd9469-9cd0-48b1-a5f2-d8e657eb8f8d", "type": "edit"}, "totalAmount": "49.5", "date": "2018-01-22 17: 15: 44"}, {"id": "33asdf", "type": 0, "message": "", "action": {"id": "21fa6ec5-8e23-4188-920b-423208fbeb78", "type": "edit"}, "totalAmount": "41.5", "date": "2018-01-22 16: 34: 03"}, {"id": "33asgsa", "type": 3, "message": "asfdasdf asdf asfasdfasdfa", "action": {"id": "898e0418-717a-4734-af2c-4bbbfa61fdea", "totalAmount": "48.1", "type": "edit"}, "date": "2018-01-22 16:34:02"}]}
      //             // eslint-disable-next-line quotes
      //             // response.data = {"success": true, "data": [{"id": "asdfsadf", "type": 3, "message": "bbbbbbbbb", "action": {"id": "21fa6ec5-8e23-4188-920b-423208fbeb78", "type": "edit"}, "date": "2018-01-22 17: 15: 44"}]}
      //             if (response.data && response.data.success) {
      //               if (response.data.data.length > 0) {
      //                 // record notification to vuex store
      //                 this.$store.commit('SET_NOTIFICATION', response.data.data)
      //                 let showingNotificationIds = []
      //                 let willShowNotificationIds = []
      //                 if (document.querySelectorAll('.content-notification .notification-wrapper').length > 0) {
      //                   Array.prototype.forEach.call(document.querySelectorAll('.content-notification .notification-wrapper'), function (el) {
      //                     if (el.querySelector('.backend-error-notification') && el.querySelector('.backend-error-notification').id) {
      //                       showingNotificationIds.push(el.querySelector('.backend-error-notification').id)
      //                     }
      //                   })
      //                 }
      //                 setTimeout(function () {
      //                   response.data.data.forEach(function (obj) {
      //                     if (obj.type && obj.type === '1' || obj.type && obj.type === '3' || obj.type && obj.type === 1 || obj.type && obj.type === 3) { // only show error message
      //                       const btnUrl = '/campaign/update/' + obj.action.id
      //                       willShowNotificationIds.push(obj.id)
      //                       if (showingNotificationIds.indexOf(obj.id) !== -1) {
      //                         // hide notification on that campaign update page
      //                         if (btnUrl === self.$route.path) {
      //                           if (document.getElementById(obj.id).querySelector('.notification-close')) {
      //                             self.eventFire(document.getElementById(obj.id).querySelector('.notification-close'), 'click')
      //                           }
      //                         }
      //                       } else {
      //                         // const btnUrl = '/' + obj.action.target + '/' + obj.action.type + '/' + obj.action.id
      //                         const btnText = 'Update Payment Method'
      //                         // const btnText = obj.button
      //                         if (btnUrl !== self.$route.path) {
      //                           // disabled, change to popup button
      //                           // self.$notify({
      //                           //   group: 'content-notification',
      //                           //   title: 'Attention',
      //                           //   text: obj.message,
      //                           //   duration: -1,
      //                           //   type: {
      //                           //     notificationId: obj.id,
      //                           //     notificationType: 'error',
      //                           //     hideClose: true,
      //                           //     // textCloseBtn: 'Got it',
      //                           //     linkBtn: [
      //                           //       {
      //                           //         url: btnUrl,
      //                           //         target: '',
      //                           //         btnText: btnText
      //                           //       }
      //                           //     ]
      //                           //   }
      //                           // })
      //                           self.$notify({
      //                             group: 'content-notification',
      //                             title: 'Attention',
      //                             text: obj.message,
      //                             duration: -1,
      //                             type: {
      //                               notificationId: obj.id,
      //                               notificationType: 'error',
      //                               hideClose: true,
      //                               popupBtn: [
      //                                 {
      //                                   popupType: 'payment',
      //                                   data: {
      //                                     campaignId: obj.action.id, // passing campaign id
      //                                     title: 'Update Payment Method',
      //                                     requestUrl: '',
      //                                     totalAmount: obj.totalAmount ? obj.totalAmount : '',
      //                                     userPaymentId: obj.userPaymentId ? obj.userPaymentId : ''
      //                                   },
      //                                   btnText: btnText
      //                                 }
      //                               ]
      //                             }
      //                           })
      //                         }
      // //                          if (btnUrl === self.$route.path) {
      // //                            if (document.getElementById(obj.id).querySelector('.notification-close')) {
      // //                              self.eventFire(document.getElementById(obj.id).querySelector('.notification-close'), 'click')
      // //                            }
      // //                          }
      //                       }
      //                     }
      //                   })
      //                   showingNotificationIds.forEach(function (showingId) {
      //                     if (willShowNotificationIds.indexOf(showingId) !== -1) {
      //                     } else {
      //                       if (document.getElementById(showingId).querySelector('.notification-close')) {
      //                         self.eventFire(document.getElementById(showingId).querySelector('.notification-close'), 'click')
      //                       }
      //                     }
      //                   })
      //                 }, 300)
      //               } else {
      //                 self.$notify({
      //                   group: 'content-notification',
      //                   clean: true,
      //                   speed: 1
      //                 })
      //               }
      //             } else {
      //               self.$notify({
      //                 group: 'content-notification',
      //                 clean: true,
      //                 speed: 1
      //               })
      //             }
      //           })
      //       }

      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    };
    Vue.prototype.$objectToQueryString = function (obj) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
      }).join('&');
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (siteUtil);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store__ = __webpack_require__(15);







// axios 配置
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 60000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_2__config_settings__["a" /* default */].remoteHost;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;

// http request 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].state.common && __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].state.common.accessToken) {
    config.headers.common['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].state.common.accessToken;
  }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 401 清除token信息并跳转到登录页面
        __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["a" /* LOGOUT */]);
        if (__WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].currentRoute.path !== '/login') {
          __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].replace({
            path: __WEBPACK_IMPORTED_MODULE_2__config_settings__["a" /* default */].basicURL + '/login',
            query: { redirect: __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].currentRoute.fullPath }
          });
        }
    }
  }
  console.log(error); // console : Error: Request failed with status code 402
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
  __webpack_require__(166)
  __webpack_require__(168)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b574727",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(204),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_auth_http__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_muse_ui__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_theme_current_less__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_theme_current_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_theme_current_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_typeface_roboto__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_typeface_roboto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_typeface_roboto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_animate_dist_vue2_animate_min_css__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_animate_dist_vue2_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_animate_dist_vue2_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_croppa__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_croppa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_croppa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_croppa_dist_vue_croppa_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_croppa_dist_vue_croppa_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_croppa_dist_vue_croppa_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuex_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_commonVariable__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_tooltip__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_meta__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_notification__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_siteUtil__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_gtag__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_muse_ui_lib_theme__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_muse_ui_lib_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_muse_ui_lib_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics_facebook_pixel__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_analytics_facebook_pixel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_analytics_facebook_pixel__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// import vueg from 'vueg'
// import 'vueg/css/transition-min.css'








// import VueQrcode from '@chenfengyuan/vue-qrcode'
// import VueMasonry from 'vue-masonry-css'







__WEBPACK_IMPORTED_MODULE_19_muse_ui_lib_theme___default.a.add('current', {
  primary: '#000000',
  secondary: '#002855'
  // success: '#4caf50',
  // warning: '#ffeb3b'
});

__WEBPACK_IMPORTED_MODULE_19_muse_ui_lib_theme___default.a.use('current');

__WEBPACK_IMPORTED_MODULE_5_muse_ui__["a" /* default */].Select.mixins[1].props.noDataText.default = 'No Data Available';

// const vuegOptions = {
//   duration: '0.3',              // 转场动画时长，默认为0.3，单位秒
//   firstEntryDisable: false,     // 值为true时禁用首次进入应用时的渐现动画，默认为false
//   firstEntryDuration: '.6',     // 首次进入应用时的渐现动画时长，默认为.6
//   forwardAnim: 'fadeInRight',   // 前进动画，默认为fadeInRight
//   backAnim: 'fadeInLeft',       // 后退动画，默认为fedeInLeft
//   sameDepthDisable: true,      // url深度相同时禁用动画，默认为false
//   // tabs: [{
//   //   name:'home'
//   // },{
//   //   name:'my'
//   // }],                       // 默认为[]，'name'对应路由的name,以实现类似app中点击tab页面水平转场效果，如tabs[1]到tabs[0]，会使用backAnim动画，tabs[1]到tabs[2]，会使用forwardAnim动画
//   tabsDisable: false,           // 值为true时，tabs间的转场没有动画，默认为false
//   shadow: true,                  // 值为false，转场时没有阴影的层次效果
//   disable: false               // 禁用转场动画，默认为false，嵌套路由默认为true
// }

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_3__service_auth_http__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$settings = __WEBPACK_IMPORTED_MODULE_12__config_settings__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_muse_ui__["a" /* default */]);
// Vue.use(router)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_gtag__["a" /* default */], {
  config: { id: 'G-32Y2CCNXJN' }
}, __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_croppa___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_v_tooltip__["a" /* default */]);
// Vue.use(VueMasonry)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__plugins_siteUtil__["a" /* default */]);
// add google analytics tracking code
// Vue.use(VueAnalytics, {
//   id: 'UA-54985207-7',
//   checkDuplicatedScript: true,
//   router,
//   debug: {
//     // enabled: process.env.NODE_ENV !== 'production',
//     // trace: process.env.NODE_ENV !== 'production',
//     sendHitTask: process.env.NODE_ENV === 'production'
//   }
//   // autoTracking: {
//   //   exception: true,
//   //   exceptionLogs: false
//   // }
// })
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_analytics_facebook_pixel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].analytics.fbq.init('827564204664748');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].analytics.fbq.event('PageView');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$commonVariable = __WEBPACK_IMPORTED_MODULE_13__config_commonVariable__["a" /* default */];

/* eslint-disable no-new */
window.app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  data: {
    // Uh oh - appName is *also* the name of the
    // instance property we defined!
    appName: 'Mondo CheckIn Portal'
  }
});

/* harmony default export */ __webpack_exports__["default"] = (window.app);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrementMain", function() { return decrementMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "incrementMain", function() { return incrementMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextStep", function() { return nextStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevStep", function() { return prevStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goStep", function() { return goStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(5);


var decrementMain = function decrementMain(_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["j" /* DECREMENT_MAIN_COUNTER */]);
};

var incrementMain = function incrementMain(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["k" /* INCREMENT_MAIN_COUNTER */]);
};

var nextStep = function nextStep(_ref3) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* NEXT_STEP */]);
};

var prevStep = function prevStep(_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* PREV_STEP */]);
};

var goStep = function goStep(_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* GO_STEP */]);
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainCounter", function() { return mainCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainStep", function() { return mainStep; });
var mainCounter = function mainCounter(state) {
  return state.counters.main;
};
var mainStep = function mainStep(state) {
  return state.step.step;
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);



var state = {
  form: {}
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["r" /* SET_CAMPAIGN_FORM */], function (state, campaignForm) {
  state.form = campaignForm;
});
var actions = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;


// this is comment
var state = {
  accessToken: null,
  login: false,
  name: '',
  email: '',
  campaignDetail: null,
  companyName: '',
  userCountry: '',
  userType: '',
  maxVenueLimit: 5,
  checkIn: { name: '', email: '', phone: '' },
  testAccount: false,
  admin: true,
  enableMarketing: false,
  enablePurchase: false,
  rootAdmin: true,
  adBlock: false,
  resellerId: '0',
  id: '',
  menu: true
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* CHANGE_LOGIN */], function (state, value) {
  state.login = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* CHANGE_MENU */], function (state, value) {
  state.menu = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* CHANGE_CAMPAIGN */], function (state, value) {
  state.campaignDetail = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* LOGOUT */], function (state) {
  state.login = false;
  state.accessToken = null;
  state.maxVenueLimit = 5;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["o" /* SAVE_CHECKIN_INFO */], function (state, value) {
  if (value.name) {
    state.checkIn.name = value.name;
  }

  if (value.email) {
    state.checkIn.email = value.email;
  }

  if (value.phone) {
    state.checkIn.phone = value.phone;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["p" /* LOGIN */], function (state, value) {
  state.login = true;
  if (value.data) {
    state.accessToken = value.data;
  }

  if (value.user && value.user.name) {
    state.name = value.user.name;
  }

  if (value.user) {
    if (value.user.reseller_id) {
      state.resellerId = String(value.user.reseller_id);
    } else state.resellerId = '0';

    if (value.user.id) {
      state.id = value.user.id;
    } else {
      state.id = '';
    }
  }

  if (value.company_name) {
    state.companyName = value.company_name;
  }

  if (value.user_country) {
    state.userCountry = value.user_country;
  }

  if (typeof value.enable_marketing !== 'undefined') {
    if (value.enable_marketing === '1' || value.enable_marketing === true) {
      state.enableMarketing = true;
    } else state.enableMarketing = false;
  }

  if (typeof value.enable_purchase !== 'undefined') {
    state.enablePurchase = value.enable_purchase;
  }

  if (value.reseller_id) {
    state.resellerId = value.reseller_id;
  }

  if (value.email) {
    state.email = value.email;
  }

  if (value.user_type || value.user_type === '') {
    state.userType = value.user_type;
    if (state.userType === '' || state.userType === 'super_admin') {
      state.rootAdmin = true;
      state.admin = true;
    } else if (state.userType === 'admin') {
      state.rootAdmin = false;
      state.admin = true;
    } else {
      state.rootAdmin = false;
      state.admin = false;
    }
  }

  if (value.test_account) {
    state.testAccount = value.test_account;
  }

  if (value.max_venue_limit) {
    state.maxVenueLimit = parseInt(value.max_venue_limit);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["q" /* CHANGE_ADBLOCK */], function (state, value) {
  if (value.adBlock) {
    if (value.adBlock === '1') {
      state.adBlock = true;
    } else {
      state.adBlock = false;
    }
  }
}), _mutations);
var actions = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  main: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* DECREMENT_MAIN_COUNTER */], function (state) {
  state.main--;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* INCREMENT_MAIN_COUNTER */], function (state) {
  state.main++;
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  notifications: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SET_NOTIFICATION */], function (state, notification) {
  state.notifications = notification;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* CLEAR_NOTIFICATION */], function (state) {
  state.notifications = [];
}), _mutations);
var actions = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  step: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* PREV_STEP */], function (state) {
  if (state.step > 0) {
    state.step--;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* NEXT_STEP */], function (state) {
  if (state.step < 5) {
    state.step++;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* GO_STEP */], function (state, step) {
  if (step >= 0 && step <= 5) {
    state.step = step;
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(5);


var _mutations;



var state = {
  systemName: 'adv',
  reseller: 0, // reseller type, 0 = no, 1=normal, 2=self serve platform reseller(saas)
  hideCost: false,
  simpleCost: false,
  showCoreg: false,
  showPayment: true, // can assign payment way or not
  showCountryStat: false, // show country/nationality stat or not
  showStateStat: true, // show state stat
  filterState: true,
  filterUserType: false,
  filterUserVisitType: false, // default no one can access
  filterTourist: true,
  filterAgeLimit: '18',
  disableFilter: '',
  commonCurrency: 'AUD',
  editCampaignCoreg: true, // enable coreg option
  editCampaign: true,
  selectCountry: true, // can select other country
  zeroLeadCost: false, // can setup 0 as lead cost
  showTermsCond: true, // show terms & conditions
  showSiteCustomerPage: false, // can display site customer stat page
  textMessage: { campaignCost: 'Revenue', source: 'Source', editCampNetwork: 'Network', filterUserType: 'User Type', filterUserVisitType: 'Visitor Type' },
  profileEnable: { company: true, email: true, billing: true },
  systemUrlCountry: 'au',
  enableSurveyModule: false,
  enableReferralModule: false,
  enableEmailPlatform: false,
  currentTimeZone: null, // use timezone setting
  testMode: false
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_SYSTEM_NAME */], function (state, hostname) {
  var commonState = void 0;
  if (hostname.hostname) {
    commonState = hostname.commonState;
    hostname = hostname.hostname;
  }
  state.hideCost = false;
  state.simpleCost = true;
  state.showCoreg = true;
  state.disableFilter = '';
  state.filterUserVisitType = false;
  state.testMode = false;
  if (hostname === 'adv.opentop.com' || hostname === 'advertiser.opentop.com') {
    state.systemName = 'adv';
  } else if (hostname.indexOf('vicinity.') >= 0) {
    state.systemName = 'vicinity';
    state.reseller = 2;
    state.simpleCost = true;
    state.showCoreg = false;
    state.zeroLeadCost = true;
    state.selectCountry = false;
    state.editCampaignCoreg = false;
  } else if (hostname.indexOf('catch.') >= 0) {
    state.systemName = 'catch';
    state.reseller = 2;
    state.simpleCost = true;
    state.showCoreg = false;
    state.disableFilter = 'gender,age';
  } else if (hostname.indexOf('ptt.') >= 0) {
    state.systemName = 'potatohead';
    state.reseller = 2;
    state.simpleCost = true;
    state.showCoreg = false;
    state.showPayment = false;
    state.selectCountry = false;
    state.textMessage.campaignCost = 'Revenue';
    state.textMessage.source = 'Zone';
    state.textMessage.editCampNetwork = 'Zone';
    state.textMessage.filterUserType = 'Guest Type';
    state.showCountryStat = true;
    state.showStateStat = false;
    state.filterState = false;
    state.filterUserType = true;
    state.filterTourist = false;
    state.zeroLeadCost = true;
    state.showSiteCustomerPage = true;
    state.showTermsCond = false;
    state.profileEnable = { company: false, email: false, billing: false };
    state.editCampaignCoreg = false;
    state.disableFilter = 'gender';
    state.filterAgeLimit = '0';
    state.commonCurrency = 'USD';
    state.enableEmailPlatform = true;
  } else if (hostname.indexOf('bac.') >= 0) {
    state.systemName = 'bac';
    state.reseller = 2;
    state.simpleCost = true;
    state.showCoreg = false;
    state.showPayment = false;
    state.selectCountry = false;
    state.textMessage.campaignCost = 'Revenue';
    state.textMessage.source = 'Zone';
    state.textMessage.editCampNetwork = 'Zone';
    state.textMessage.filterUserType = 'Guest Type';
    state.showCountryStat = true;
    state.showStateStat = true;
    state.filterState = true;
    state.filterUserType = false;
    state.filterTourist = true;
    state.zeroLeadCost = true;
    state.showSiteCustomerPage = true;
    state.showTermsCond = false;
    state.profileEnable = { company: false, email: false, billing: false };
    state.editCampaignCoreg = false;
    state.disableFilter = 'gender,age';
    state.commonCurrency = 'AUD';
    state.currentTimeZone = { 'value': 'Australia/Brisbane', 'text': 'Australia/Brisbane (UTC/GMT +10:00)' };
    state.enableEmailPlatform = true;
    state.enableSurveyModule = true;
  } else if (hostname.indexOf('localhost') >= 0) {
    state.enableSurveyModule = true;
    state.enableReferralModule = true;
  } else {
    state.systemName = 'adv';
    if (hostname.indexOf('minicards.') >= 0) {
      // state.hideCost = true
      state.simpleCost = true;
      // state.editCampaign = false
    }
  }

  if (state.reseller === 2) {
    state.showTermsCond = false;
  }

  if (commonState && commonState.testAccount) {
    state.enableSurveyModule = true;
    state.enableReferralModule = true;
    state.showSiteCustomerPage = true;
    state.enableEmailPlatform = true;
    state.filterUserVisitType = true;
    state.simpleCost = true;
    state.hideCost = true;
    state.showTermsCond = false;
    state.testMode = true;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_SYSTEM_URL_COUNTRY */], function (state, hostname) {
  if (hostname === 'eu-advertiser.opentop.com') {
    state.systemUrlCountry = 'es';
  } else {
    state.systemUrlCountry = 'au';
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_SYSTEM_VALUE */], function (state, value) {
  if (value.hideCost !== undefined) {
    state.hideCost = value.hideCost;
  }

  if (value.showCoreg !== undefined) {
    state.showCoreg = value.showCoreg;
  }

  if (value.test_account === true) {
    state.enableSurveyModule = true;
    state.enableReferralModule = true;
    state.showSiteCustomerPage = true;
    state.enableEmailPlatform = true;
    state.filterUserVisitType = true;
    state.simpleCost = true;
    state.hideCost = true;
    state.showTermsCond = false;
    state.testMode = true;
  }
}), _mutations);
var actions = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raw_loader_components_theme_advTheme_txt__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raw_loader_components_theme_advTheme_txt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raw_loader_components_theme_advTheme_txt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_asider__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_asider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_asider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import sensisTheme from 'raw-loader!./components/theme/sensisTheme.txt'





/* harmony default export */ __webpack_exports__["default"] = ({
  store: __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */],
  name: 'MondoCheckInPortal',
  components: {
    'app-nav': __WEBPACK_IMPORTED_MODULE_2__components_common_asider___default.a,
    'loadingDiv': __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default.a
  },
  beforeCreate: function beforeCreate() {
    // check system and set to store
    var hostname = location.host;
    this.$store.commit('SET_SYSTEM_NAME', { 'hostname': hostname, 'commonState': this.$store.state.common });
    this.$store.commit('SET_SYSTEM_URL_COUNTRY', hostname);
  },
  data: function data() {
    var desktop = isDesktop();
    return {
      open: desktop,
      docked: desktop,
      desktop: desktop,
      hideBar: true,
      checkinPage: false,
      title: '',
      theme: 'advTheme',
      themes: {
        advTheme: __WEBPACK_IMPORTED_MODULE_0_raw_loader_components_theme_advTheme_txt___default.a
      }
    };
  },


  computed: {
    login: function login() {
      return this.$store.state.common.login;
    },
    name: function name() {
      return this.$store.state.common.name;
    }
  },
  watch: {
    login: function login(value) {
      if (value && isDesktop()) {
        this.open = true;
      }
      this.changeNav();
    },
    '$route': 'routeChange'
  },

  methods: {
    changeTheme: function changeTheme(theme) {
      this.theme = theme;
      var styleEl = this.getThemeStyle();
      styleEl.innerHTML = this.themes[theme] || '';
    },
    getThemeStyle: function getThemeStyle() {
      var themeId = 'muse-theme';
      var styleEl = document.getElementById(themeId);
      if (styleEl) return styleEl;
      styleEl = document.createElement('style');
      styleEl.id = themeId;
      document.body.appendChild(styleEl);
      return styleEl;
    },
    changeToPage: function changeToPage(url) {
      this.$router.push({ path: url });
    },
    eventFire: function eventFire(el, etype) {
      if (el.fireEvent) {
        el.fireEvent('on' + etype);
      } else {
        var evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
      }
    },
    routeChange: function routeChange() {
      if (this.$route.path === '/registration' || this.$route.path.indexOf('/checkin/') >= 0 || this.$route.path === '/' || this.$route.path === '') {
        this.hideBar = true;
      } else {
        this.hideBar = false;
      }
      if (this.$route.path.indexOf('/checkin/') >= 0) {
        this.checkinPage = true;
      } else {
        this.checkinPage = false;
      }
      console.log(this.$route);
    },
    test: function test() {
      var value = false;
      if (this.login) {
        value = false;
      } else value = true;
      this.$store.commit('CHANGE_LOGIN', value);
      this.changeNav();
    },
    toggleNav: function toggleNav() {
      this.open = !this.open;
    },
    changeNav: function changeNav() {
      var desktop = isDesktop();
      this.docked = desktop;

      if (!this.login) {
        this.open = false;
      } else {
        if (desktop === this.desktop) return;
        if (!desktop && this.desktop && this.open) {
          this.open = false;
        }
        if (desktop && !this.desktop && !this.open) {
          this.open = true;
        }
        this.desktop = desktop;
      }
    },
    handleMenuChange: function handleMenuChange(path) {
      if (!this.desktop) this.open = false;
    },
    setTitle: function setTitle() {
      var path = window.location.hash;
      if (path && path.length > 1) path = path.substring(1);
      for (var i = 0; i < this.routes.length; i++) {
        var route = this.routes[i];
        if (route.path === path) {
          this.title = path.substring(1) || '';
          return;
        }
      }
    },
    logout: function logout() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__vuex_mutation_types__["a" /* LOGOUT */]);
      this.$store.commit('CLEAR_NOTIFICATION');
      // this.$notify({
      //   group: 'content-notification',
      //   clean: true,
      //   speed: 1
      // })
      this.$notify({
        group: 'top-right-common',
        clean: true,
        speed: 1
      });
      // this.$notify({
      //   group: 'campaign-notification',
      //   clean: true,
      //   speed: 1
      // })
      // turn on full page loading animation for logout
      document.getElementById('progress_bar').style.right = '100vw';
      document.getElementById('full-page-loading').classList.add('show');
      document.getElementById('loading-text').innerHTML = 'Logging you out...';
      setTimeout(function () {
        // fake progress bar animation
        document.getElementById('progress_bar').style.right = '50vw';
      }, 100);
      setTimeout(function () {
        // fake progress bar animation
        document.getElementById('progress_bar').style.right = '10vw';
      }, 800);
      this.changeNav();
      this.$router.push({ path: '/login' });

      if (document.getElementsByClassName('custom-active').length > 0) {
        document.getElementsByClassName('custom-active')[0].classList.remove('custom-active');
      }
    }
  },
  created: function created() {
    // if (this.$store.state.system.systemName === 'sensis') {
    // this.changeTheme('sensisTheme')
    // }
    this.routeChange();
  },
  mounted: function mounted() {
    var _this = this;

    console.log('System: ' + this.$store.state.system.systemName);
    this.routes = this.$router.options.routes;
    this.setTitle();
    this.changeNav();
    this.handleResize = function () {
      _this.changeNav();
    };
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('hashchange', function () {
      _this.setTitle();
    });
    // remove scroll change number in all number input
    document.addEventListener('mousewheel', function (event) {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
});

function isDesktop() {
  return window.innerWidth > 800;
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_muse_ui_src_SubHeader_SubHeader__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_muse_ui_es5_List_ListItem__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_muse_ui_es5_List_List__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MuList: __WEBPACK_IMPORTED_MODULE_2_muse_ui_es5_List_List__["a" /* default */],
    MuListItem: __WEBPACK_IMPORTED_MODULE_1_muse_ui_es5_List_ListItem__["a" /* default */],
    MuSubHeader: __WEBPACK_IMPORTED_MODULE_0_muse_ui_src_SubHeader_SubHeader__["a" /* default */] },
  props: {
    open: {
      type: Boolean,
      default: true
    },
    docked: {
      type: Boolean,
      default: false
    }
  },

  created: function created() {
    console.log('init menu');
    this.checkOpenCategory();
  },
  data: function data() {
    return {
      campaignOpen: false,
      accountOpen: false
    };
  },


  watch: {
    '$route.path': function $routePath(value) {
      this.checkOpenCategory();
    }
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    logout: function logout() {
      this.$emit('logout');
    },
    checkOpenCategory: function checkOpenCategory() {
      if (this.$route.path.indexOf('/venue/') >= 0) {
        this.campaignOpen = true;
        this.accountOpen = false;
      } else if (this.$route.path.indexOf('/account/') >= 0) {
        this.accountOpen = true;
        this.campaignOpen = false;
      } else {
        this.accountOpen = false;
        this.campaignOpen = false;
      }
    },
    mobileClose: function mobileClose() {
      if (window.innerWidth <= 800) {
        this.$emit('close');
      }
    }
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: ''
  }
});

/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MondoConneX_Logo.45cb2ce.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mondoconnex-logo-icon@2x.45d8912.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(205),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.checkinPage ? 'checkin-background' : ''],
    attrs: {
      "id": "app"
    }
  }, [_c('notifications', {
    attrs: {
      "group": "top-right-common",
      "position": "top right",
      "width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('div', {
          class: ['notification', 'custom-notification', props.item.type.notificationType, props.item.type.hideClose ? 'hide-close' : '']
        }, [_c('div', {
          staticClass: "notification-content-wrap"
        }, [_c('div', {
          staticClass: "notification-title"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('div', {
          staticClass: "notification-content",
          domProps: {
            "innerHTML": _vm._s(props.item.text)
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "notification-btn-wrap"
        }, [(props.item.type.textCloseBtn) ? _c('div', {
          class: ['notification-close-btn', 'notification-btn', props.item.type.notificationType],
          on: {
            "click": props.close
          }
        }, [_vm._v(_vm._s(props.item.type.textCloseBtn))]) : _vm._e(), _vm._v(" "), (props.item.type.linkBtn) ? _c('div', _vm._l((props.item.type.linkBtn), function(btn, key) {
          return _c('a', {
            key: key,
            class: ['notification-link-btn', 'notification-btn', props.item.type.notificationType],
            attrs: {
              "href": btn.url,
              "target": btn.target
            },
            on: {
              "click": props.close
            }
          }, [_vm._v(_vm._s(btn.btnText))])
        }), 0) : _vm._e()])]), _vm._v(" "), (props.item.type.hideClose !== true) ? _c('div', {
          staticClass: "notification-close",
          on: {
            "click": props.close
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("clear")])]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('loadingDiv', {
    attrs: {
      "type": "full-page-loading"
    }
  }), _vm._v(" "), (!_vm.hideBar) ? _c('mu-appbar', {
    staticClass: "header-content",
    class: {
      'nav-hide': !_vm.open, 'login-page': !_vm.login, 'open': _vm.open
    },
    attrs: {
      "zDepth": 0,
      "title": ""
    }
  }, [(!_vm.login) ? [_c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "nav-logo",
    attrs: {
      "slot": "left",
      "src": __webpack_require__(32)
    },
    slot: "left"
  })]), _vm._v(" "), (_vm.$route.path !== '/registration') ? _c('mu-button', {
    staticClass: "top-button mobile-hide",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "right",
      "textColor": "white",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeToPage(_vm.$settings.basicURL + '/registration')
      }
    },
    slot: "right"
  }, [_vm._v("\n        Registration\n      ")]) : _vm._e(), _vm._v(" "), _c('mu-button', {
    staticClass: "top-button mobile-hide",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "right",
      "textColor": "white",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeToPage(_vm.$settings.basicURL + '/login')
      }
    },
    slot: "right"
  }, [_vm._v("\n        Login\n      ")]), _vm._v(" "), _c('mu-button', {
    staticClass: "demo-flat-button menu-icon mobile-show",
    attrs: {
      "slot": "right",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "left": "",
      "value": "menu"
    }
  }), _vm._v("Menu\n      ")], 1)] : _vm._e(), _vm._v(" "), (_vm.login) ? [_c('div', {
    attrs: {
      "id": "nav-title"
    }
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "nav-logo mobile-show",
    attrs: {
      "slot": "left",
      "src": __webpack_require__(32)
    },
    slot: "left"
  })]), _vm._v(" "), _c('mu-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.desktop),
      expression: "!desktop"
    }],
    staticClass: "menu-icon mobile-hide",
    staticStyle: {
      "color": "black",
      "padding": "0",
      "margin-top": "3px"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "left": "",
      "value": "menu"
    }
  })], 1), _vm._v(" "), _c('mu-button', {
    staticClass: "top-button mobile-hide",
    attrs: {
      "slot": "right",
      "textColor": "black"
    },
    on: {
      "click": _vm.logout
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "value": "input",
      "left": ""
    }
  }), _vm._v("Log out\n      ")], 1), _vm._v(" "), _c('mu-button', {
    staticClass: "demo-flat-button menu-icon mobile-show",
    attrs: {
      "slot": "right",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "left": "",
      "value": "menu"
    }
  }), _vm._v("Menu\n      ")], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.hideBar) ? _c('app-nav', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked
    },
    on: {
      "change": _vm.handleMenuChange,
      "close": _vm.toggleNav,
      "logout": _vm.logout
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'nav-hide': !_vm.open, 'hide-bar': _vm.hideBar, 'checkin-background': _vm.checkinPage
    },
    style: ({
      'padding-bottom': _vm.login === true && !_vm.hideBar ? '100px' : 'auto'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1), _vm._v(" "), (_vm.login && !_vm.checkinPage) ? _c('div', {
    staticClass: "bottom-image desktop",
    staticStyle: {
      "bottom": "0",
      "position": "fixed",
      "width": "calc(100vw - 256px)",
      "left": "256px"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.login && !_vm.checkinPage) ? _c('div', {
    staticClass: "bottom-image mobile"
  }, [_vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://bit.ly/30GsULD",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "80%",
      "max-height": "150px"
    },
    attrs: {
      "src": __webpack_require__(42)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://bit.ly/30GsULD",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "95%",
      "max-height": "150px"
    },
    attrs: {
      "src": __webpack_require__(42)
    }
  })])])
}]}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.type
    }
  }, [_c('div', {
    attrs: {
      "id": "loading-text"
    }
  }), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pattern_div"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "spinning-cog",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": __webpack_require__(201)
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_progress"
    }
  }, [_c('div', {
    attrs: {
      "id": "progress_bar"
    }
  })])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.state.common.login) ? _c('div', {
    staticClass: "content-left menuSide"
  }, [_c('div', {
    class: [_vm.open ? 'open' : '', 'header-logo']
  }, [_c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "margin-top": "5px"
    },
    attrs: {
      "src": __webpack_require__(32)
    }
  })])]), _vm._v(" "), _c('mu-drawer', {
    staticStyle: {
      "padding-top": "65px"
    },
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked,
      "overlay": _vm.docked
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "mu-list-wrap",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "padding-bottom": "355px"
    },
    attrs: {
      "toggle-nested": ""
    },
    on: {
      "itemClick": function($event) {
        _vm.docked ? '' : _vm.close()
      }
    }
  }, [_c('mu-list-item', {
    staticClass: "menu-company-name"
  }, [_c('mu-list-item-title', [_vm._v(_vm._s(_vm.$store.state.common.companyName))])], 1), _vm._v(" "), _c('mu-list-item', {
    staticClass: "menu-sub-title"
  }, [_c('mu-list-item-title', [_vm._v("Venue")])], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "button": "",
      "avatar": "",
      "to": _vm.$settings.basicURL + '/venue/list',
      "id": "side-nav-your-campaigns"
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "business"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Your Venues")])], 1), _vm._v(" "), (_vm.$store.state.common.admin) ? _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/venue/leads',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "toc"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Contact Tracing Database")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.admin) ? _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/venue/marketing-list',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "contacts"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Your Marketing List")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.rootAdmin && (_vm.$store.state.common.enablePurchase || _vm.$store.state.common.enableMarketing)) ? _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/invoices',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "payment"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Invoices")])], 1) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
    staticClass: "menu-sub-title"
  }, [_c('mu-list-item-title', [_vm._v("Account")])], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/profile',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "account_box"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Profile")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu-bottom-wrap"
  }, [_c('div', {
    staticClass: "list-line"
  }), _vm._v(" "), _c('mu-list', [_c('mu-list-item', {
    staticClass: "no-icon-item sub-item small-text",
    attrs: {
      "button": "",
      "href": 'https://www.mondoconnex.com/contact',
      "target": "_blank"
    },
    on: {
      "click": _vm.mobileClose
    }
  }, [_c('mu-list-item-title', [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('mu-list-item', {
    staticClass: "mobile-show",
    staticStyle: {
      "padding": "10px 0",
      "border-top": "1px solid #3c3c3c"
    },
    attrs: {
      "button": "",
      "avatar": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "input"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Log out")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu-bottom-text-content"
  }, [_vm._v("\n              MondoConneX © 2020"), _c('br'), _vm._v("v2.0\n            ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.common.login) ? _c('div', {
    staticClass: "content-left menuSide"
  }, [_c('mu-drawer', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked,
      "overlay": _vm.docked
    },
    on: {
      "close": _vm.close
    }
  }, [_c('mu-appbar', {
    staticClass: "mobile-menu-appbar",
    attrs: {
      "title": ""
    }
  }, [_c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "margin-top": "27px"
    },
    attrs: {
      "src": __webpack_require__(200)
    }
  })])]), _vm._v(" "), _c('mu-list', {
    on: {
      "itemClick": function($event) {
        _vm.docked ? '' : _vm.close()
      }
    }
  }, [_c('mu-list-item', {
    attrs: {
      "button": "",
      "avatar": "",
      "to": _vm.$settings.basicURL + '/registration'
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "assignment"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Registration")])], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/login',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "assignment_ind"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Login")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu-bottom-wrap"
  }, [_c('div', {
    staticClass: "side-menu-bottom-text-content"
  }, [_vm._v("\n            MondoConneX © 2020"), _c('br'), _vm._v("v1.0\n          ")])])], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./campaignForm.js": 121,
	"./common.js": 122,
	"./counters.js": 123,
	"./index.js": 48,
	"./notification.js": 124,
	"./step.js": 125,
	"./system.js": 126
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;

/***/ })
],[118]);


// WEBPACK FOOTER //
// static/js/app.cb2fd559f1f285297cd6.js